import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { Paper,  } from '@mui/material';
import {  ShopVisitCard, } from '../components';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { trackActivity } from "../../../utils/mixpanel";
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { RoleBaseAccess } from "../../../hoc";
import ShopvisitNavigationHeader from "../components/ShopvisitNavigationHeader";
import { getEngineLLPApi, getShopVisitApi, getShopVisitFundBalanceApi } from "../apiServices";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { getStorage } from "../../../shared_elements/actionCreators";
import fileUpload from "../../../utils/fileUpload";
import FileUploadLayout from "../../../shared_elements/components/FileUploadLayout";
import { buildEditShopVisit } from "../components/ShopVisitCru";
import SSkeletonLoader from "../../../shared_elements/skeleton_loader/SSkeletonLoader";

const ShopVisitView = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const { leaseBasicDetails, fileUploadDetails } = useSelector((state) => state.leases);
  const assetData = leaseBasicDetails?.asset
  const [shopVisit, setShopVisit] = useState({ cost: "", shop_visit_start_date: null, shop_visit_end_date: null});
  const [llpModuleData, setLlpModuleData] = useState([])
  const [isLoading, setLoading] = useState({ buttonLoader: false, pageLoader: false })
  const [fundBalanceLoader, setFundBalanceLoader] = useState(false)
  const [dropdownLoader, setDropdownLoader] = useState({ engine_llp: false })
  const [slug, setSlug] = useState({})
  const [uploadFileProgressData, setUploadFileProgressData] = useState({})
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Shop Visit View' })
  }, [])
  const getEngineLLPs = async (assetData) => {
    setDropdownLoader((prev) => ({ ...prev, engine_llp: true }))
    const response = await globalGetService(getEngineLLPApi("engine", assetData?.slug || assetData?.asset_slug))
    setDropdownLoader((prev) => ({ ...prev, engine_llp: false }))
    if (response) {
      if (checkApiStatus(response)) {
        const { llp = [], non_llp = [] } = response?.data?.data || {}
        const updatedData = [
          ...llp.map((ele) => ({ label: ele?.name, value: `${ele?.name?.toLowerCase()}_event`, isLlp: true, id: ele?.id })),
          ...non_llp.map((ele) => ({ label: ele?.name, value: `${ele?.name?.toLowerCase()}_event`, isLlp: false, id: ele?.id })),
        ]
        setLlpModuleData(updatedData)
      }
    }
  };
  const getShopVisit = async () => {
    setLoading({ pageLoader: true })
    try {
      const response = await globalGetService(getShopVisitApi(params?.slug))
      if (checkApiStatus(response)) {
        setShopVisit(prevState => ({
          ...prevState,
          ...buildEditShopVisit(response?.data?.data),
        }));
        getShopVisitFundBalance(response?.data?.data)
        if ((assetData && ((assetData?.asset_type === 1 && response?.data?.data?.major_assembly?.asset_type === 2) || assetData?.asset_type === 2))) {
          getEngineLLPs(assetData?.asset_type === 1 ? response?.data?.data?.major_assembly : assetData)
        }
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "shop_visit" }))
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        return null
      }
    } finally {
      setLoading({ pageLoader: false })
    }
  }
  const getShopVisitFundBalance = (shopVisit) => {
    setFundBalanceLoader(true)
    return globalGetService(getShopVisitFundBalanceApi(shopVisit,))
      .then(response => {
        if (checkApiStatus(response)) {
          setShopVisit(prev => ({
            ...prev,
            fund_balance: response?.data?.data
          }));
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        }
      })
      .finally(() => { setFundBalanceLoader(false) })
  }
  const onFieldChange = (key, value) => { setShopVisit({ ...shopVisit, [key]: value }) }
  const handleUpload = async (slug, mode,key=null) => {
    setSlug({ slug: slug })
    await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: key ? key : 'shop_visit',
      slug: slug,
      query: { record_action_type: mode },
      onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments }) => {
        setUploadFileProgressData({ progressRefs, attachments });
      },
      onSuccess: (success_msg) => {
        enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
        getShopVisit("", { per_page: 50 });
      },
      onError: (err) => {
        enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
      }
    });
    setSlug({})
  }
  useEffect(() => { if (assetData) { getShopVisit() } }, [assetData])
  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Shop Visit" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
          <div className='lease-details-content' >
            <ShopvisitNavigationHeader shopVisit={shopVisit} />
            {leaseBasicDetails?.asset ? <ShopVisitCard assetData={assetData} isLoading={isLoading} fundBalanceLoader={fundBalanceLoader} dropdownLoader={dropdownLoader} shopVisit={shopVisit} llpModuleData={llpModuleData} handleUpload={handleUpload} onFieldChange={onFieldChange} getShopVisit={getShopVisit} getShopVisitFundBalance={getShopVisitFundBalance} /> : <SSkeletonLoader />}
          </div>}
      </Paper>

      <FileUploadLayout
        uploadFileStatus={uploadFileStatus}
        open={uploadFileStatus?.modal}
        setUploadFileStatus={setUploadFileStatus}
        uploadFileProgressData={uploadFileProgressData}
        progressRefs={uploadFileProgressData?.progressRefs}
        attachments={uploadFileProgressData?.attachments}
        onDownloadComplete={() => setSlug({})}
      />

    </>
  )
}

export default RoleBaseAccess(ShopVisitView, { application: 'lease_revamp', feature: 'shop_visit', operationType: ['R'] });